import { Injectable, signal } from '@angular/core';

export type ToastVariant = 'success' | 'error' | 'info';

/**
 * App-wide toast state. One toast at a time, latest wins — matching the behavior the wizard's
 * component-local toast always had. Rendered once by ToastOutletComponent in the dashboard
 * shell; feature code only calls show().
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  readonly toast = signal<{ message: string; variant: ToastVariant } | null>(null);
  private timer: ReturnType<typeof setTimeout> | null = null;

  show(message: string, variant: ToastVariant = 'info', durationMs = 3000): void {
    if (this.timer) clearTimeout(this.timer);
    this.toast.set({ message, variant });
    this.timer = setTimeout(() => this.toast.set(null), durationMs);
  }
}
